import React, { Component } from "react";
import axios from "axios";

import { Link } from "react-router-dom";
import domain from ".././../../../domain";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { Button } from "mdbreact";
import { Row, Col, Card, CardBody } from "mdbreact";

const moment = require("moment-timezone");
function indexN(cell, row, enumObject, index) {
  return <div>{index + 1}</div>;
}
function dateFormatter(cell) {
  return moment(cell).tz("Asia/Kolkata").format("DD/MM/YYYY");
}
function timeFormatter(cell) {
  // return moment(cell,"h:mm a").format("HH:mm a")
  return moment(cell, "h:mm a").format("hh:mm a");
}

class ScheduleByCourseId extends Component {
  constructor() {
    super();
    this.state = {
      sessions: [],
      course_id: "",
      course_name: "",
      status: "",
    };
  }

  componentDidMount() {
    this.getSessions();
    this.getCourse();
  }
  editButtonFormatter = (row) => {
    return this.state.status === "Completed" ? (
      <Link className="btn blue disabled" to="#">
        EDIT
      </Link>
    ) : (
      <Link className="btn blue " to={`/edit-session/${row}`}>
        EDIT
      </Link>
    );
  };
  deleteButtonFormatter = (row) => {
    return this.state.status === "Completed" ? (
      <Button name="delete" value={row} disabled>
        DELETE
      </Button>
    ) : (
      <Button name="delete" value={row} onClick={this.onDelete.bind(this)}>
        DELETE
      </Button>
    );
  };
  onDelete = (e) => {
    //       console.log(e.target)
    e.preventDefault();
    let r = window.confirm("Do you want to delete session details");
    if (r) {
      axios
        .delete(`${domain.DBServer}/delete-session/${e.target.value}`)
        .then((response) => {
          console.log(response.data);
          if (response.data === 1) {
            alert("Session details deleted Successfully");
            window.location.reload();
          } else {
            alert("Error while deletion");
            window.location.reload();
          }
        })
        .catch((err) => console.log(err));
    } else return false;
  };
  async getCourse() {
    let courseId = this.props.match.params.id;
    let result = await axios.get(`${domain.DBServer}/fetch-course/${courseId}`);
    this.setState({
      course_name: result.data[0].title,
      status: result.data[0].status,
    });
  }

  getSessions() {
    let courseId = this.props.match.params.id;
    axios
      .get(`${domain.DBServer}/fetch-sessions/${courseId}`)
      .then((response) => {
        console.log(response.data);
        this.setState(
          { sessions: response.data, course_id: response.data[0].course_id },
          () => {}
        );
      })
      .catch((err) => console.log(err));
  }

  render() {
    const options = {
      exportCSVText: "Custom Export CSV Text",
    };
    let coursetable;
    if (this.state.sessions != null) {
      coursetable = (
        <BootstrapTable
          data={this.state.sessions}
          exportCSV
          striped
          hover
          version="4"
          options={options}
          // selectRow={selectRowProp}
          pagination
          csvFileName="courseschedule.csv"
          search
          // tableStyle={ { border: '#0000FF 2.5px solid' } }
          // containerStyle={ { border: '#FFBB73 2.5px solid' } }
          headerStyle={{
            border: "red 1px solid",
            textAlign: "center",
            color: "blue",
          }}
          bodyStyle={{ border: "green 1px solid" }}
          keyField="course_session_id"
        >
          <TableHeaderColumn
            width="50px"
            dataFormat={indexN}
            dataAlign="right"
            export={false}
          >
            S. No
          </TableHeaderColumn>
          {/* <TableHeaderColumn dataField='course_session_id'  dataSort width='100px'>Session Id</TableHeaderColumn> */}
          <TableHeaderColumn
            dataField="lecturer_name"
            dataSort
            filter={{ type: "TextFilter" }}
          >
            Lecturer Name
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="title"
            dataSort
            filter={{ type: "TextFilter" }}
            width="300px"
          >
            Topic
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="session_date"
            dataFormat={dateFormatter}
            dataSort
            filter={{ type: "TextFilter" }}
          >
            Date
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="start_time"
            dataFormat={timeFormatter}
            dataSort
            filter={{ type: "TextFilter" }}
          >
            Start Time
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="end_time"
            dataFormat={timeFormatter}
            dataSort
            filter={{ type: "TextFilter" }}
          >
            End Time
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="course_session_id"
            dataFormat={this.editButtonFormatter}
            export={false}
          >
            Edit
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="course_session_id"
            dataFormat={this.deleteButtonFormatter}
            export={false}
          >
            Delete
          </TableHeaderColumn>
        </BootstrapTable>
      );
    }

    return (
      <div>
        <Row>
          <Col md="12">
            <Card>
              <CardBody>
                {/* <Link className="btn grey" to="/Home">Back</Link> */}
                {console.log(this.props)}
                {this.state.status !== "Completed" ? (
                  <Link
                    className="btn blue disabled"
                    to="#"
                    style={{ textAlign: "right" }}
                  >
                    Add More Sessions
                  </Link>
                ) : (
                  <Link
                    className="btn blue"
                    to={`/add-schedule/${this.props.match.params.id}`}
                    style={{ textAlign: "right" }}
                  >
                    Add More Sessions
                  </Link>
                )}
                <h3 style={{ textAlign: "center", color: "blue" }}>
                  {this.state.course_name}
                </h3>
                <h4 style={{ textAlign: "center", color: "blue" }}>
                  List of Sessions
                </h4>

                <div>{coursetable}</div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default ScheduleByCourseId;
